import type { CSSProperties, ReactNode } from "react";
import { Box } from "@mui/material";

export const HACK_alignIconWithLabel: CSSProperties = { transform: "translateY(1px)" };

export const HACK_alignIconWithLabelBox = ({ children }: { children: ReactNode }) => {
  return (
    <Box component="span" sx={{ display: "inline-block", ...HACK_alignIconWithLabel }}>
      {children}
    </Box>
  );
};
